import React from 'react';
import { UPDATE_EMPLOYEE_PEOPLE_MANAGEMENT_RULES } from 'domain/shared/employee';
import FormActionButtons from 'domain/people/employee/shared/button/showEdit/FormActionButtons';
import EmployeePeopleManagersField from 'domain/people/employee/shared/field/EmployeePeopleManagersField';
import EditFormShowButton from '../../shared/button/showEdit/EditFormShowButton';
import { useFormShowContext } from 'framework/form';
import PeopleManagementSpecifySection from 'domain/people/employee/shared/input/PeopleManagementSpecifySection';
import { Box } from '@mui/material';

const MenagmentContent = () => {
  const { isEditMode } = useFormShowContext();

  return (
    <Box>
      <Box sx={{ position: 'absolute', right: '-15px', top: 0 }}>
        {isEditMode ? null : <EditFormShowButton requiredPermission={UPDATE_EMPLOYEE_PEOPLE_MANAGEMENT_RULES} />}
      </Box>

      {isEditMode ? (
        <Box display="flex" flexDirection="column">
          <PeopleManagementSpecifySection />
          <FormActionButtons sxWrapper={{ justifyContent: 'flex-end', ml: 0 }} />
        </Box>
      ) : (
        <EmployeePeopleManagersField />
      )}
    </Box>
  );
};

export default MenagmentContent;
